'use strict';

var Consts = require('consts');
var FilterTemplate = require('utils/templates/device_filter');
var Decorator = require('utils/decoration');
var DropDownList = require('utils/dropdown_list');
var DeviceDropDownList = require('utils/device_dropdown_list');
var I18N = require('utils/i18n');
var QuickNavigation = require('components/common/templates/quick_navigation');
var Strings = require('utils/strings');
var ColorPicker = require('utils/colorpicker');
var Log = require('utils/log');

var Misc = {};

var colorTemplate = require('components/devices/templates/common/chart_configure_line_color');
var defaultColors = [
    'rgb(255, 0, 0)',
    'rgb(0, 128, 0)',
    'rgb(0, 0, 255)',
    'rgb(255, 128, 0)',
    'rgb(0, 0, 0)',
    'rgb(0, 128, 128)',
    'rgb(255, 0, 255)',
    'rgb(150, 75, 0)',
    'rgb(192, 0, 0)',
    'rgb(0, 0, 128)',
    'rgb(192, 0, 92)',
    'rgb(92, 92, 92)',
];

var messageViewTemplate = require('components/common/templates/message');
function messageView(id, className, message, title) {
    return messageViewTemplate({
        text: message,
        color_class: className,
        titleID: id,
        title: title,
    });
}

Misc.getValue3State = function (ddl) {
    var value = ddl.val();
    if (ddl.attr('data-can-exclude') != 'true') return value;

    var $div = ddl.closest('div');
    var $selected = $div.find('ul').find('li.selected');
    var $options = ddl.find('option');

    var result = [];
    _.each($selected, function (item) {
        var $item = $(item);
        if ($item.hasClass('selected')) {
            var idx = parseInt($item.attr('data-original-index'));
            var isExcluded = $item.hasClass('excluded');
            if ($options.length > idx) {
                var $option = $($options[idx]);
                result.push('' + (isExcluded ? '_-_' : '') + $option.attr('value'));
            }
        }
    });

    return result;
};

// returns the key of key:value JSON object. When there is no key with given value, it uses the key with "null" value (when available)
Misc.keyOf = function (obj, value) {
    for (var key in obj) {
        if (obj[key] == value) return key;
    }

    // no key found? use one with "null" as value
    for (var key in obj) {
        if (obj[key] === null) {
            return key;
        }
    }

    return undefined;
};

// converts a value from the "currentDictionary" into a corresponding value of the "newDictionary"
Misc.convertValue = function (value, currentDictionary, newDictionary, notFound) {
    var key = this.keyOf(currentDictionary, value);
    if (key !== undefined && newDictionary[key] !== undefined) return newDictionary[key];
    else return notFound;
};

// converts a comma-separated text of values from the "currentDictionary" into a comma separated text of corresponding values from "newDictionary"
Misc.convertList = function (list, currentDictionary, newDictionary) {
    var ar = list;
    if (list.split) ar = list.split(',');

    var newArray = [];

    for (var i = 0; i < ar.length; i++) {
        if (ar[i] == '') continue;

        var newValue = this.convertValue(ar[i], currentDictionary, newDictionary);
        if (typeof newValue !== undefined) {
            newArray.push(newValue);
        }
    }

    return newArray.join(',');
};

// build a comma separated text with result values of a function applied to each element of the array
Misc.commaListSelect = function (list, getValueFunc, separator) {
    var result = '';
    separator = separator || ', ';

    _.each(list, function (v) {
        result = result + (result == '' ? '' : separator) + getValueFunc(v);
    });

    return result;
};

// compares array of arrays - returns true if they all are equal
Misc.arraysEqual = function (arrays) {
    if (arguments.length != 1) {
        return Misc.arraysEqual(arguments);
    }

    if (arrays.length <= 1) {
        return true;
    }

    function arraysEqual(arrayA, arrayB) {
        if (arrayA.length !== arrayB.length) {
            return false;
        }
        for (var i = 0; i < arrayA.length; i++) {
            if (arrayA[i] !== arrayB[i]) {
                return false;
            }
        }
        return true;
    }

    for (var i = 1; i < arrays.length; i++) {
        if (!arraysEqual(arrays[0], arrays[i])) {
            return false;
        }
    }

    return true;
};

Misc.commaListAttr = function (list, key, separator) {
    return Misc.commaListSelect(
        list,
        function (x) {
            return x[key];
        },
        separator
    );
};

// finds an object in an array with specific key. When returnIdx is true,
// it returns the index, otherwise the object itself.
Misc.findWithKey = function (list, key, value, returnIdx) {
    for (var i = 0; i < list.length; i++) {
        if (list[i][key] === value) {
            return returnIdx ? i : list[i];
        }
    }
};

// Converts the given intArray into an array with bit values, assuming that
// the integer values are 16-bit values. The bit array is inverted.
//
// Example: [1023] -> [1, 1, 1, 1, 1, 1, 1, 1,
//                     1, 1, 0, 0, 0, 0, 0, 0 ]
Misc.int2bitArray = function (intArray) {
    var result = [];

    for (var i = 0; i < intArray.length; i++) {
        for (var j = 0; j < 16; j++) {
            result.push((intArray[i] >> j) & 1);
        }
    }

    return result;
};

// Converts the given bitArray into an array with 16-bit integer values.
// Inverts int2bitArray.
Misc.bit2intArray = function (bitArray) {
    var result = [];
    var currentValue = 0;

    for (var i = 0; i < bitArray.length; i++) {
        if (i != 0 && i % 16 == 0) {
            result.push(currentValue);
            currentValue = 0;
        }
        currentValue = currentValue >> 1;
        currentValue += bitArray[i] << 15;
    }
    result.push(currentValue);

    return result;
};

Misc.getDeviceURL = function (category, id, tab) {
    var categoryKey = Consts.DeviceCategory[category].categoryKey;
    return (Consts.CategoryData[categoryKey] || {}).url + '/' + id + (tab ? '/' + tab : '');
};

Misc.initializeMultiSelect = function (elem, selectable, selected, enableSearch) {
    var multiSelectConfig = {
        selectableHeader: '<span class="font-600">' + selectable + '</span>',
        selectionHeader: '<span class="font-600">' + selected + '</span>',
    };

    if (enableSearch === true) {
        // add search input fields
        var searchBoxSelectableHtml =
            '<input id="ct-selectable" type="text" class="form-control search-input m-t-10" autocomplete="off" placeholder="' +
            I18N.TR('Suche...') +
            '">';
        var searchBoxSelectedHtml =
            '<input id="ct-selected" type="text" class="form-control search-input m-t-10" autocomplete="off" placeholder="' +
            I18N.TR('Suche...') +
            '">';

        multiSelectConfig.selectableHeader += searchBoxSelectableHtml;
        multiSelectConfig.selectionHeader += searchBoxSelectedHtml;

        // add methods
        multiSelectConfig.afterInit = function (ms) {
            var self = this;

            var $selectableSearch = self.$selectableUl.prev();
            var $selectionSearch = self.$selectionUl.prev();
            var selectableSearchString = '#' + self.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
            var selectionSearchString = '#' + self.$container.attr('id') + ' .ms-elem-selection.ms-selected';

            self.qs1 = $selectableSearch.quicksearch(selectableSearchString).on('keydown', function (e) {
                if (e.which === 40) {
                    self.$selectableUl.focus();
                    return false;
                }
            });

            self.qs2 = $selectionSearch.quicksearch(selectionSearchString).on('keydown', function (e) {
                if (e.which == 40) {
                    self.$selectionUl.focus();
                    return false;
                }
            });
        };
        multiSelectConfig.afterSelect = function () {
            this.qs1.cache();
            this.qs2.cache();
        };
        multiSelectConfig.afterDeselect = function () {
            this.qs1.cache();
            this.qs2.cache();
        };
    }

    $(elem).multiSelect(multiSelectConfig);
};

Misc.loadFromDOMElement = function (rootObj, rootElement) {
    // make children out of child nodes
    function fixChildren(obj) {
        if (!obj.children && obj.childNodes) {
            obj.children = obj.childNodes;
        }
        _.each(obj.children, function (a) {
            fixChildren(a);
        });
    }

    fixChildren(rootElement);

    // attributes are just saved as properties
    _.each(rootElement.attributes, function (attr) {
        rootObj[attr.name] = isNaN(attr.value) ? attr.value : parseInt(attr.value);
    });

    // children
    _.each(rootElement.children, function (a) {
        // if the object has the attribute "id", it will be saved inside of an object with "element" name and property of id
        // if the object has the attribute "idx", it will be saved inside of an array with "element" name and index of idx
        var tagName = a.tagName;
        var countOfMe = $(rootElement).find(a.tagName).length;
        var objId = $(a).attr('id');
        var objIdx = $(a).attr('idx');
        var hasId = objId !== null && objId !== undefined;
        var hasIdx = objIdx !== null && objIdx !== undefined;

        // to make it easy. When there is idx but not id, let id be idx and used in the same way
        if (!hasId && hasIdx) objId = parseInt(objIdx);

        // process the element as an array?
        var isSingleObject = (a.children.length == 0 || a.attributes.length > 0) && countOfMe == 1 && !hasId && !hasIdx;

        // create object
        if (!rootObj[tagName]) {
            if (isSingleObject || hasId) rootObj[tagName] = {};
            else rootObj[tagName] = [];
        }

        // simple objects are just processed in the same manner
        if (isSingleObject) {
            Misc.loadFromDOMElement(rootObj[tagName], a);
        } else {
            // add a child into an object
            var addObj = function (ar, r, id) {
                var newObj = {};
                if (id !== undefined) {
                    if (ar[id] === undefined) ar[id] = newObj;
                    else newObj = ar[id];
                } else ar.push(newObj);
                Misc.loadFromDOMElement(newObj, r);
            };

            if (countOfMe > 1 || hasId || hasIdx) {
                addObj(rootObj[tagName], a, objId);
            } else {
                _.each(a.children, function (ch) {
                    addObj(rootObj[tagName], ch);
                });
            }
        }
    });
};

Misc.loadAdditionalFile = function (url, filetype) {
    var fileRef = undefined;

    var urlCache = window.urlCache || {};
    if (urlCache[url]) {
        // file already loaded
        return;
    }

    switch (filetype) {
        case 'js':
            var fileRef = document.createElement('script');
            fileRef.setAttribute('type', 'text/javascript');
            fileRef.setAttribute('src', url);
            break;
        case 'css': {
            var fileRef = document.createElement('link');
            fileRef.setAttribute('rel', 'stylesheet');
            fileRef.setAttribute('type', 'text/css');
            fileRef.setAttribute('href', url);
            break;
        }
    }

    if (fileRef) {
        document.getElementsByTagName('head')[0].appendChild(fileRef);

        // update url cache
        urlCache[url] = true;
        window.urlCache = urlCache;
    }
};

// leadingZero prepands zero or more '0' to input so that it has the minimum given minLength (default = 2)
Misc.leadingZero = function (input, minLength) {
    var paddingLength = Math.max((minLength || 2) - input.toString().length, 0);
    return '0'.repeat(paddingLength) + input;
};

Misc.undefineDate = function (x) {
    if (x && new Date(x).getYear() === 0) return undefined;
    return x;
};

Misc.getMeterErrorsFromStatus = function (errorCode) {
    var result = [];
    var add = function (msg) {
        result.push({ text: msg });
    };

    // split error code
    var operatingState = (errorCode & 0xffff0000) >>> 16;
    var errorState = (errorCode & 0x0000ff00) >>> 8;

    // meter timeout?
    if ((operatingState & 0x0080) != 0) {
        add(I18N.TR('Zähler antwortet nicht'));
    }
    // any other operating error
    if ((operatingState & 0xff7f) != 0) {
        add(I18N.TR('MBus-Fehler'));
    }

    // resolve error status register
    if ((errorState & 0x03) == 3) {
        add(I18N.TR('Ungewöhnlicher Zustand'));
    } else {
        if ((errorState & 0x02) != 0) {
            add(I18N.TR('Beliebiger Applikationsfehler'));
        }
    }
    if ((errorState & 0x04) != 0) {
        add(I18N.TR('Energiereserve niedrig'));
    }
    if ((errorState & 0x08) != 0) {
        add(I18N.TR('Permanenter Fehler'));
    }
    if ((errorState & 0x10) != 0) {
        add(I18N.TR('Temporärer Fehler'));
    }
    if ((errorState & 0xe0) != 0) {
        add(I18N.TR('Zählerspezifischer Fehler') + ' (' + ((errorState & 0xe0) >>> 5) + ')');
    }

    return result;
};

Misc.getErrorsFromStatus = function (errorCode, category, errorStatusTexts) {
    // special case handling: meter errors
    if (category == Consts.Category.Meter && errorCode > 0) {
        return Misc.getMeterErrorsFromStatus(errorCode);
    }

    if (typeof errorStatusTexts == 'string') {
        if (errorStatusTexts) {
            errorStatusTexts = JSON.parse(errorStatusTexts);
        }
    }

    var categoryData = Consts.CategoryData[_.invert(Consts.Category)[category]];
    var errorValues = categoryData.statusErrors.codes;
    var errorTexts = categoryData.statusErrors.messages;

    var result = [];

    var addError = function (key) {
        var code = errorValues[key];
        var additionalText = '';

        if (errorStatusTexts && errorStatusTexts[code]) {
            additionalText += ' (' + errorStatusTexts[code] + ')';
        }

        result.push({
            code: code,
            text: errorTexts[key] + additionalText,
        });
    };

    _.each(errorValues, function (code, key) {
        if (errorCode <= 0 && code <= 0 && errorCode == code) addError(key);
        if (errorCode > 0 && code > 0 && (errorCode & code) == code) addError(key);
    });

    return result;
};

Misc.getCoordinates = function (event) {
    var pos = { x: 0, y: 0 };
    var coordinateSource = undefined;

    if (event.pageX != undefined) {
        coordinateSource = event;
    } else if (event.originalEvent.touches && event.originalEvent.touches.length > 0) {
        coordinateSource = event.originalEvent.touches[0];
    } else if (event.originalEvent.changedTouches && event.originalEvent.changedTouches.length > 0) {
        coordinateSource = event.originalEvent.changedTouches[0];
    }

    if (coordinateSource) {
        pos.x = coordinateSource.pageX;
        pos.y = coordinateSource.pageY - (window.scrollY || 0);
    }

    return pos;
};

// Specified value is 'clamped' into the range [min, max].
Misc.clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
};

// Returns 'true' if n is a float value or a string containing a float value.
Misc.isFloat = function (n) {
    if (_.isNull(n) || _.isUndefined(n)) {
        return false;
    }

    // contains any invalid char?
    var baseRegex = /^[0-9.-]+$/;
    if (!baseRegex.test(n)) {
        return false;
    }

    // contains other invalid patterns?
    var invalidRegex = /(^[-]?0[^.,]+|^[.-]$|.-)/;
    if (invalidRegex.test(n)) {
        return false;
    }

    // contains more than one special char ('.' or '-')
    if (n.split && n.split('.').length > 2) {
        return false;
    }
    if (n.split && n.split('-').length > 2) {
        return false;
    }

    return !isNaN(parseFloat(n));
};

// Returns 'true' if n is an integer value. Thanks IE.
Misc.isInteger = function (n) {
    return Number.isInteger ? Number.isInteger(n) : typeof n === 'number' && isFinite(n) && Math.floor(n) === n;
};

Misc.generatePagination = function (pagesSettings) {
    var template = require('components/common/templates/abstract_table_pagination');
    return {
        html: template(pagesSettings),
        initEvents: function () {
            // install document handler
            if (!window.isPaginationDocHandler) {
                window.isPaginationDocHandler = true;
                $('html').on('click', function (e) {
                    $('.picker-pagination-options').hide();
                });
            }

            var gotoPage = function (p) {
                if (pagesSettings.context && pagesSettings.onGotoPage && p >= 1 && p <= pagesSettings.pageCount) {
                    pagesSettings.onGotoPage.apply(pagesSettings.context, [p]);
                }
            };

            _.each($('button.js-pagination-select'), function (x) {
                if (!x.hasClickEvent) {
                    x.hasClickEvent = true;
                    $(x).on('click', function (e) {
                        $(e.currentTarget).closest('span').find('.picker-pagination-options').toggle();
                        e.stopPropagation();
                    });
                }
            });

            // select page
            _.each($(pagesSettings.context.$el).find('.js-select-current-page').find('ul li a'), function (x) {
                if (!x.hasClickEvent) {
                    x.hasClickEvent = true;
                    $(x).on('click', function (e) {
                        gotoPage(parseInt($(x).data('value')));
                    });
                }
            });

            // select items per page page
            _.each($(pagesSettings.context.$el).find('.js-select-items-per-page').find('ul li a'), function (x) {
                if (!x.hasClickEvent) {
                    x.hasClickEvent = true;
                    $(x).on('click', function (e) {
                        if (pagesSettings.onSetItemsPerPage) {
                            var value = parseInt($(x).data('value'));
                            pagesSettings.onSetItemsPerPage.apply(pagesSettings.context, [value]);
                        }
                    });
                }
            });

            // left, right
            _.each($(pagesSettings.context.$el).find('.pagination-btn'), function (x) {
                if (!x.hasClickEvent) {
                    x.hasClickEvent = true;
                    $(x).on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        var isNext = $(x).hasClass('next');
                        if (isNext) gotoPage(parseInt(pagesSettings.currentPage) + 1);
                        else gotoPage(parseInt(pagesSettings.currentPage) - 1);
                    });
                }
            });
        },
    };
};

Misc.selectWhere = function (data, filterFunc, selectFunc, isDistinct) {
    if (filterFunc) {
        var filterType = typeof filterFunc;
        if (filterType == 'string' || filterType == 'number')
            data = _.filter(data, function (a) {
                return a[filterFunc];
            });
        else data = _.filter(data, filterFunc);
    }
    if (selectFunc) {
        if (typeof selectFunc == '')
            data = _.map(data, function (item) {
                return item[selectFunc];
            });
        else if (typeof selectFunc == 'string') data = _.pluck(data, selectFunc);
        else data = _.map(data, selectFunc);
    }
    if (isDistinct) data = _.uniq(data);
    return data;
};

Misc.selectWhereFirst = function (data, filterFunc, selectFunc, isDistinct) {
    var result = Misc.selectWhere(data, filterFunc, selectFunc, isDistinct);
    if (result.length > 0) return result[0];
    return undefined;
};

Misc.selectFieldFct = function (list, key, value) {
    return function (k) {
        return Misc.selectWhereFirst(
            list,
            function (item) {
                return item[key] == k;
            },
            function (item) {
                if (typeof value === 'function') {
                    return value(item);
                }

                if (value === undefined) return item;
                return item[value];
            }
        );
    };
};

Misc.countWhere = function (data, filterFunc, isDistinct) {
    var list = Misc.selectWhere(
        data,
        filterFunc,
        function (a) {
            return a;
        },
        isDistinct
    );
    return list.length;
};

Misc.getChartLineLabel = function (idx, sourceData, showCustom, AppState) {
    var allDevices = [];
    _.each(sourceData.devices, function (c) {
        allDevices.push(c.devices);
    });
    allDevices = _.flatten(allDevices);

    var lines = sourceData.lines;
    var smartTempData = sourceData.smartTempData || [];
    var weatherData = sourceData.weatherData || [];

    var line = lines[idx];
    if (line.customLabel && showCustom) return line.customLabel;

    // are all devices the same?
    var devices = Misc.selectWhere(
        lines,
        function (a) {
            return a.deviceID > 0;
        },
        function (a) {
            return parseInt(a.deviceID);
        },
        true
    );

    // are all series the same?
    var series = Misc.selectWhere(
        lines,
        function (a) {
            return a.field;
        },
        function (a) {
            return a.field;
        },
        true
    );

    var getFieldName = function (l) {
        var name = Misc.selectWhereFirst(
            l.series,
            function (a) {
                return a.field == l.field;
            },
            'name'
        );
        if (name) {
            name = I18N.DATAPOINT_BY_ID(l.deviceID, name);
        }

        return (
            name ||
            Misc.selectWhereFirst(
                smartTempData,
                function (a) {
                    return a.field == l.field;
                },
                'name'
            ) ||
            Misc.selectWhereFirst(
                weatherData,
                function (a) {
                    return a.field == l.field;
                },
                'name'
            )
        );
    };

    var getDeviceName = function (l) {
        var deviceInfo = AppState.getDeviceInfo(l.deviceID);
        return deviceInfo.name;
    };

    var getLabel = function (i) {
        if (lines[i].customLabel && showCustom) return lines[i].customLabel;
        if (devices.length < 2) {
            return getFieldName(lines[i]) || '';
        }
        if (series.length < 2) {
            return getDeviceName(lines[i]);
        }

        var serieName = getFieldName(lines[i]) || '';
        return getDeviceName(lines[i]) + (serieName ? ' - ' : '') + (serieName || '');
    };

    var myLabel = getLabel(idx);
    var prevCount = Misc.selectWhere(lines, function (a) {
        return a.index < idx && myLabel == getLabel(a.index);
    });

    myLabel = myLabel + (prevCount.length > 0 ? ' (' + (prevCount.length + 1) + ')' : '');
    return myLabel;
};

Misc.log10 = function (x) {
    return Math.log(x) / Math.log(10);
};

Misc.calculateNormRange = function (valueRange, limit) {
    var min = Math.min(valueRange.max || 0, valueRange.min || 0);
    var max = Math.max(valueRange.max || 0, valueRange.min || 0);

    // constant range? -> adapt
    if (max == min) {
        return {
            min: max == 0 ? -5 : 0.99 * min,
            max: max == 0 ? 5 : 1.01 * max,
        };
    }

    var lowerBound = (Math.trunc(min / 100) - (min < 0 ? 1 : 0)) * 100;
    if (limit !== undefined) {
        // consider lower limit
        lowerBound = lowerBound < limit.min ? Math.min(limit.min, min) : lowerBound;
    }

    var getStepWidth = function (range) {
        var nx = Math.pow(10, Math.ceil(Misc.log10(range)));
        return nx == 10 ? 5 : nx / 10;
    };

    var steps = 0;
    var stepWidth = getStepWidth(max - min);

    // determine result min
    steps = Math.trunc(Math.abs(min - lowerBound) / stepWidth);
    var resultMin = lowerBound + steps * stepWidth;

    // determine result max
    var resultMax = resultMin;
    while (resultMax < max) {
        resultMax += stepWidth;
    }

    if (limit !== undefined) {
        // consider upper limit
        resultMax = resultMax > limit.max ? Math.max(limit.max, max) : resultMax;
    }

    return {
        min: Misc.roundValue(resultMin),
        max: Misc.roundValue(resultMax),
    };
};

Misc.normalizeRange = function (r, options) {
    options = options || {};

    var range = Misc.calculateNormRange(r, options.limits);

    if (options.addPadding == true) {
        // make it 1% bigger
        var d = range.max - range.min;
        range.max = range.max + d * 0.05;
        range.min = range.min - d * 0.05;
    }

    return range;
};

Misc.roundValue = function (x) {
    var threshold = Math.pow(2, 31);
    if (x > threshold) {
        // subtract everything over
        var base = x - (x % threshold);
        var diff = x - base;
        diff = Misc.roundValue(diff);
        return base + diff;
    }

    if (x == 0) return 0;
    var isNeg = x < 0;
    x = Math.abs(x);
    var order = Math.floor(Misc.log10(x));
    x = x / Math.pow(10, order);
    var o1 = order + 9;
    var o2 = -9;

    var n = x + 'e' + (o1 < 0 ? '' : '+') + o1;
    var n = Math.round(n);
    n = n + 'e' + (o2 < 0 ? '' : '+') + o2;
    n = parseFloat(n);
    return (isNeg ? -1 : 1) * n;
};

Misc.groupBy = function (data, key, createFunc) {
    var groups = _.uniq(_.pluck(data, key));
    return _.map(groups, function (group) {
        var groupContent = Misc.selectWhere(data, function (item) {
            return item[key] == group;
        });
        if (createFunc) return createFunc(group, groupContent);
        else
            return {
                name: group,
                items: groupContent,
            };
    });
};
Misc.getOperatorText = function (l1, op, l2) {
    var calcOp = Misc.selectWhereFirst(Consts.Backend.Operators, function (a) {
        return a.value == op;
    });
    if (!calcOp) return l1 + op + l2;

    var fmt = calcOp.format || '$1 @op $2';
    return fmt.replace('$1', l1).replace('$2', l2).replace('@op', I18N.TR(calcOp.name));
};

Misc.getValueDisplayInfos = function (value, type, format, unit, outputUnit, isUnitFixed) {
    if (!unit && outputUnit) {
        unit = outputUnit;
    }

    if (!isUnitFixed) {
        outputUnit = undefined;
    }

    if (value == undefined || value == 32767) {
        return { value: '--', unit: '' };
    }

    type = Strings.getValueTypeClass(type);
    if (type.startsWith('UNSPECIFIED')) {
        type = 'UNSPECIFIED';
    }

    var formattedValue = Strings.formatValue(value, type, format);

    if (type === 'MBC') {
        // coils -> return as formatted
        var adjustedValue = { value: I18N.TR(formattedValue), unit: '' };
    } else if (!Misc.isFloat(formattedValue)) {
        // not a number -> return as-is
        var adjustedValue = { value: formattedValue, unit: unit };
    } else {
        // numeric value in register -> adjust units
        var adjustedValue = Strings.adjustUnits(formattedValue, unit, outputUnit);
    }

    return adjustedValue;
};

Misc.getRawValue = function (value, type, format) {
    format = format || '';
    var result = undefined;

    // format with /xxxxx
    var formatRegEx = /\/([0-9]+)/g;
    var m = formatRegEx.exec(format);
    result = parseFloat(value);
    if (m && m[1]) {
        result = parseFloat(value) * parseFloat(m[1]);
    }

    if (type == 'MBR') result = Math.floor(result);

    return result;
};

Misc.getStringWidth = function (s) {
    var name = 'tmp-string-measure';
    var span = $('#' + name);
    var measuringSpan;
    if (span.length == 0) {
        measuringSpan = document.createElement('span');
        measuringSpan.id = name;
        measuringSpan.style.display = 'none';
        $('body')[0].appendChild(measuringSpan);
    } else {
        measuringSpan = span[0];
    }
    measuringSpan.innerText = s;
    return $(measuringSpan).width();
};

Misc.getStatusErrorText = function (err, category, statusDataText) {
    var catIndex = _.invert(Consts.Category)[category];
    var additionalText = '';
    if (statusDataText && statusDataText[err]) {
        additionalText = ' (' + statusDataText[err] + ')';
    }

    return (
        Misc.convertValue(err, Misc.getCategoryErrorCodes(catIndex) || {}, Misc.getCategoryErrorTexts(catIndex) || {}) +
        additionalText
    );
};

Misc.getCategoryErrorCodes = function (catIndex) {
    var catData = Consts.CategoryData[catIndex];
    if (!catData || !catData.statusErrors) return undefined;
    return catData.statusErrors.codes;
};

Misc.getCategoryErrorTexts = function (catIndex) {
    var catData = Consts.CategoryData[catIndex];
    if (!catData || !catData.statusErrors) return undefined;
    return catData.statusErrors.messages;
};

Misc.categoryKey = function (category) {
    return _.invert(Consts.Category)[category];
};

Misc.categoryData = function (category) {
    return Consts.CategoryData[Misc.categoryKey(category)];
};

Misc.timestampFormat = function (value) {
    return moment(value).format('YYYY_MM_DD_HH_mm_ss');
};

Misc.buildPermissionList = function (rightsBase, categories) {
    var rights = undefined;
    _.each(categories, function (cat) {
        var r = rightsBase[cat];
        if (rights === undefined) {
            rights = r;
            return;
        }
        rights = _.intersection(rights, r);
    });

    return rights;
};

Misc.getCategoryColumns = function (category) {
    if (category && Consts.CategoryData[category]) {
        return Consts.CategoryData[category].columns;
    }

    // not found?
    var cols = {};
    _.each(Consts.CategoryData, function (c) {
        _.each(c.columns, function (ci) {
            cols[ci.id] = ci.name;
        });
    });
    var result = [];
    _.each(cols, function (value, key) {
        result.push({ id: key, name: value });
    });

    return result;
};

Misc.getDeviceErrorText = function (err) {
    if (!err) return '';
    err = err.trim();
    switch (err) {
        case 'limit_reached':
            return I18N.TR('Sie haben die maximale Anzahl der Geräte in dieser Kategorie erreicht.');
    }
    return err;
};

Misc.initDevicePicker = function (options) {
    options = options || {};
    var selector = options.selector || '.devicepicker';
    _.each($(selector), function (item) {
        DeviceDropDownList.initialize(item, options);
    });
};

Misc.initColorButtons = function (customColors) {
    customColors = customColors || defaultColors;

    var createColorButtons = function (originalColor) {
        var colors = _.clone(customColors) || []; //  _.toArray($.extend(true, [], customColors));
        colors.push(undefined);
        return colorTemplate({
            colors: _.map(colors, function (col) {
                return {
                    color: col === undefined ? originalColor : col,
                    custom: col === undefined,
                };
            }),
        });
    };

    var btnSelector = $('button.js-color');
    btnSelector.popover({
        html: true,
        animation: true,
        placement: 'auto',
        trigger: 'focus',
        container: 'div.modal-dialog',
        sanitizeFn: function (x) {
            return x;
        },
        content: function (e) {
            return createColorButtons($(this).css('background-color'));
        },
        title: function (e) {
            return I18N.TR('Wählen Sie bitte eine Farbe aus');
        },
    });

    btnSelector.on('click', function (e) {
        $(e.target).popover('toggle');
    });

    btnSelector.on('shown.bs.popover', function (e) {
        var popoverID = $(e.currentTarget).attr('aria-describedby');
        var $popover = $('div#' + popoverID);

        $popover.find('button').on('mousedown', function (btn) {
            // self.colorButtonClicked = true;
            var btn = $(btn.currentTarget);
            var selectedColor = $(btn).css('background-color');

            // locate my popover
            var $div = $('div.popover');
            var id = $div.length && $div[0].id;

            // locate my button
            var $btn = $('button.js-color[aria-describedby="' + id + '"]');
            $btn.css('background-color', selectedColor);

            // trigger the change
            setTimeout(function () {
                if ($btn.length) {
                    $btn.change();
                }
            });
        });

        var ctrlCustomColor = $(e.target).next().find('button.js-custom-color');
        ctrlCustomColor = $('button.js-custom-color');
        var cp = new ColorPicker(ctrlCustomColor, {
            wrapperClass: 'chart-color-select',
            owner: '.chart-colorpicker',
        });
    });
};

Misc.initSelectPicker = function (options) {
    options = options || {};
    options.size = options.size || 10;
    options.noneSelectedText = options.noneSelectedText || I18N.TR('Keine Auswahl');
    options.noneResultsText = options.noneResultsText || I18N.TR('Keine Einträge gefunden');
    options.class = options.class || '';

    var selector = options.selector || '.selectpicker';

    _.each($(selector), function (item) {
        if (options.visibleOnly && !$(item).parent().is(':visible')) {
            return;
        }

        var $item = $(item);
        if ($item[0]) {
            if ($item[0].isInitialized) {
                return;
            }
            $item[0].isInitialized = true;
        }

        var itemCount = $item.find('option').length;
        var objOptions = $.extend({}, false, options);
        var isMultiSelect = $item.attr('multiple');

        objOptions.liveSearch = itemCount > 4;
        objOptions.actionsBox = isMultiSelect && itemCount > 4;
        objOptions.deselectAllText = I18N.TR('Keine');
        objOptions.selectAllText = I18N.TR('Alle');

        DropDownList.initialize($item, objOptions);
        if (options.class != '') {
            $item.selectpicker('setStyle', options.class, 'add');
        }
    });
};

Misc.listDistinctKey = function (list, key) {
    var obj = {};
    _.each(list, function (item) {
        if (item && item[key] !== undefined) obj[item[key]] = item;
    });

    var result = [];
    _.each(obj, function (value) {
        result.push(value);
    });

    return result;
};

Misc.initTimePicker = function (container, options) {
    var $tpck = $('.js-timepicker');
    options = $.extend(
        {
            showMeridian: false,
            appendWidgetTo: container,
        },
        options
    );
    $tpck.timepicker(options).on('show.timepicker', function (e) {
        var $inputs = $('.bootstrap-timepicker-widget table td input');
        $inputs.addClass('form-control input-sm');
        $inputs.css('width', '85px');
        setTimeout(function () {
            var $picker = $('div.bootstrap-timepicker-widget');
            $picker.css('z-index', 9999);
        });
    });
};

Misc.setDatePickerOptions = function (options) {
    options = options || {};
    var defaults = {
        locale: {
            format: self.rangeFormat,
            applyLabel: I18N.TR('Setzen'),
            cancelLabel: I18N.TR('Abbrechen'),
            daysOfWeek: Consts.DaysOfWeek,
            monthNames: Consts.MonthNames,
            firstDay: 1,
        },
        timePicker: true,
        timePicker24Hour: true,
        buttonClasses: ['btn', 'btn-sm'],
        applyClass: 'btn-default',
        cancelClass: 'btn-white',
    };
    return $.extend(true, options, defaults);
};

Misc.initDatePicker = function (options) {
    options = options || {};
    var closest = options.closest || '.input-group';
    _.each($('.js-datepicker').closest(closest), function (x) {
        var c = $(x).closest('div');

        if (!$.fn.datepicker.dates['current']) {
            var dayNames = [];
            _.each(Consts.DayNames, function (item, idx) {
                dayNames[idx != 6 ? idx + 1 : 0] = item;
            });

            $.fn.datepicker.dates['current'] = {
                days: dayNames,
                daysShort: Misc.selectWhere(dayNames, undefined, function (item) {
                    return item.substr(0, 3);
                }),
                daysMin: Misc.selectWhere(dayNames, undefined, function (item) {
                    return item.substr(0, 2);
                }),
                months: Consts.MonthNames,
                monthsShort: Misc.selectWhere(Consts.MonthNames, undefined, function (item) {
                    return item.substr(0, 3);
                }),
                today: I18N.TR('Heute'),
                clear: I18N.TR('Leer'),
                format: 'dd.mm.yyyy',
                weekStart: 1,
            };
        }
        var defaultOptions = {
            autoclose: true,
            format: 'dd.mm.yyyy',
            orientation: 'left',
            todayHighlight: true,
            container: c,
            language: 'current',
        };
        options = $.extend(true, defaultOptions, options);
        $(x).datepicker(options);
    });
};

Misc.parseFloatDef = function (x, def) {
    var r = parseFloat(x);
    return isNaN(r) ? def || 0 : r;
};

Misc.parseIntDef = function (x, def) {
    var r = parseInt(x);
    return isNaN(r) ? def || 0 : r;
};

Misc.getEnumItems = function (format) {
    var result = [];
    if (format.substr(0, 2) == 'r{') {
        var data = JSON.parse(format.substr(1, format.length));
        _.each(data, function (value, key) {
            result.push({ value: key, text: value });
        });
    }

    if (format.indexOf('/') > 0) {
        var parts = format.split('/');

        _.each(parts, function (part) {
            var subParts = part.split('-(');
            if (subParts.length == 2) {
                result.push({ value: parseInt(subParts[1]), text: subParts[0] });
            }
        });
    }

    return result;
};

Misc.filterToJSON = function (filter) {
    var result = JSON.stringify(
        _.omit(filter, function (x) {
            return x === undefined || x === null;
        })
    );
    var encoded = encodeURIComponent(result);
    return encoded;
};

Misc.filterFromJSON = function (filter) {
    filter = decodeURIComponent(filter);
    var result = JSON.parse(filter);
    return result;
};

Misc.filterToStr = function (filter, columnMap, deviceGroups) {
    var templateCtx = {
        aspects: [],
        matchesAllDevices: false,
    };

    // explicitly selected devices?
    if (filter.selection) {
        return FilterTemplate({
            aspects: [
                {
                    caption: I18N.TR('Explizit ausgewählte Geräte'),
                    value: '',
                    available: true,
                },
            ],
            matchesAllDevices: false,
        });
    }

    // search text
    templateCtx.aspects.push({
        caption: I18N.TR('Suchtext'),
        value: filter.search_text,
        available: filter.search_text !== undefined,
    });

    // device category
    templateCtx.aspects.push({
        caption: I18N.TR('Gerätekategorien'),
        value: Misc.selectWhere(filter.category, undefined, function (item) {
            return (Consts.DeviceCategory[item] || { name: '?' }).name;
        }).join(', '),
        available: filter.category !== undefined,
    });

    // device groups
    templateCtx.aspects.push({
        caption: I18N.TR('Gerätegruppen'),
        value: Misc.selectWhere(
            _.flatten([
                _.map(filter.device_groups, function (g) {
                    return { group: g, excluded: false };
                }),
                _.map(filter.device_groups_excluded, function (g) {
                    return { group: g, excluded: true };
                }),
            ]),
            undefined,
            function (item) {
                return (
                    '<span class="' +
                    (item.excluded ? 'excluded' : '') +
                    '">' +
                    Handlebars.escapeExpression(deviceGroups[item.group]) +
                    '</span>'
                );
            }
        )
            .sort()
            .join(', '),
        available: filter.device_groups !== undefined,
        containsHtml: true,
    });

    // status
    templateCtx.aspects.push({
        caption: I18N.TR('Status'),
        value: _.map(filter.status, function (i) {
            var icon = Misc.convertValue(i, Consts.DeviceStatusURL, Consts.Icons);
            var text = Misc.convertValue(i, Consts.DeviceStatusURL, Consts.DeviceStatusText);
            return '<i class="m-r-5 ' + icon + '"></i> ' + text;
        }).join('<br>'),
        available: filter.status !== undefined,
        containsHtml: true,
    });

    // labels

    var getLabel = function (item, type) {
        var isExcluded = item.startsWith('_-_');
        if (isExcluded) {
            item = item.substr(3);
        }
        return (
            '<span class="' +
            (isExcluded ? 'excluded ' : '') +
            'label label-block label-' +
            type +
            '">' +
            Handlebars.escapeExpression(item) +
            '</span>'
        );
    };

    var getTag = function (item) {
        return getLabel(item, 'tags');
    };
    var getGroup = function (item) {
        return getLabel(item, 'groups');
    };

    templateCtx.aspects.push({
        caption: I18N.TR('Label'),
        value: _.map(filter.tags, getTag).concat(_.map(filter.groups, getGroup)).join(' '),
        available: filter.tags !== undefined || filter.groups !== undefined,
        containsHtml: true,
    });

    // conditions
    var formatValue = function (x, id) {
        var fieldInfo = columnMap[id] || {};
        if (fieldInfo && fieldInfo.fieldGroup == Consts.FieldGroup.Data && fieldInfo.unit) {
            var di = Misc.getValueDisplayInfos(x, id, fieldInfo.format, fieldInfo.unit);
            return di.value + ' ' + di.unit;
        }
        return x;
    };

    var conditions = [];
    var hasHiddenConditions = false;

    _.each(filter.conditions, function (cond) {
        var fieldInfo = columnMap[cond.field] || '?';
        var field2Info = fieldInfo.fieldGroup == Consts.FieldGroup.Data ? columnMap[cond.value] : undefined;
        field2Info = field2Info && field2Info.fieldGroup == Consts.FieldGroup.Data ? field2Info : undefined;

        hasHiddenConditions = hasHiddenConditions || !fieldInfo.name;

        if (fieldInfo.name) {
            var valueStr = Misc.isFloat(cond.value)
                ? formatValue(parseFloat(cond.value), cond.field)
                : moment.utc(cond.value, 'DD.MM.YYYY hh:mm').isValid()
                  ? moment.utc(cond.value, 'DD.MM.YYYY hh:mm').local().format('DD.MM.YYYY hh:mm')
                  : cond.value;

            conditions.push(
                Handlebars.escapeExpression(fieldInfo.name) +
                    ' ' +
                    cond.op +
                    ' ' +
                    Handlebars.escapeExpression((field2Info && field2Info.name) || valueStr)
            );
        }
    });

    templateCtx.aspects.push({
        caption: I18N.TR('Bedingungen'),
        value: conditions.join('<br>'),
        available: filter.conditions !== undefined && filter.conditions.length,
        containsHtml: true,
        hint: hasHiddenConditions ? I18N.TR('Enthält weitere Bedingungen.') : undefined,
    });

    // no aspects available? -> group contains all devices
    templateCtx.matchesAllDevices = !_.reduce(
        templateCtx.aspects,
        function (memo, a) {
            return memo || a.available;
        },
        false
    );

    return FilterTemplate(templateCtx);
};

Misc.filterToMap = function (filter) {
    filter = _.omit(filter, function (x) {
        return x === undefined || x === null;
    });
    if ('{}' === JSON.stringify(filter)) {
        return filter;
    }
    return { filter: JSON.stringify(filter) };
};

Misc.removeQueryFromURL = function (url) {
    var queryStart = url.indexOf('?');
    return queryStart == -1 ? url : url.substring(0, queryStart);
};

Misc.getBackgroundTaskManager = function () {
    return {
        tasks: [],
        add: function (task) {
            var self = this;
            _.each(arguments, function (task) {
                self.tasks.push(task);
                $.when(task).done(function () {
                    var idx = self.tasks.indexOf(task);
                    self.tasks.splice(idx, 1);
                });
            });
        },

        isBusy: function () {
            return this.tasks.length > 0;
        },

        whenArray: function (ar) {
            // add all
            var self = this;
            _.each(ar, function (task) {
                self.add(task);
            });

            return $.when.apply(this, ar);
        },

        when: function (task) {
            return this.whenArray([task]);
        },

        done: function (fct, owner) {
            $.when.apply(this, this.tasks).done(function () {
                fct.apply(owner, arguments);
            });
        },
    };
};

Misc.formatValueUnitBySpec = function (value, field, valueSpec, isBasicUnit) {
    var isFixedUnit = isBasicUnit === true || (valueSpec && valueSpec.is_unit_fixed === true);
    var fixedUnit =
        isFixedUnit && valueSpec !== undefined
            ? (isBasicUnit ? valueSpec.unit : valueSpec.display_unit) || valueSpec.unit
            : undefined;

    var valueUnit = Misc.getValueDisplayInfos(value, field, valueSpec.format, valueSpec.unit, fixedUnit, isFixedUnit);

    return {
        value: valueUnit.value || value,
        unit: valueUnit.unit || '',
    };
};

Misc.formatValueUnit = function (value, field, availColumns, isBasicUnit, customAttributes) {
    var valueSpec = $.extend(
        Misc.selectWhereFirst(availColumns, function (item) {
            return item.id == field;
        }),
        customAttributes
    );

    return Misc.formatValueUnitBySpec(value, field, valueSpec, isBasicUnit);
};

Misc.formatValueUnitStr = function (value, field, availColumns, isBasicUnit, customAttributes) {
    var result = Misc.formatValueUnit(value, field, availColumns, isBasicUnit, customAttributes);
    return result.value + ' ' + result.unit;
};

Misc.getTimePeriodList = function () {
    return [
        {
            name: 'free',
            text: I18N.TR('Frei'),
            from: undefined,
            till: undefined,
            free: true,
        },
        {
            text: '15 ' + I18N.TR('Minuten'),
            name: '15minutes',
            from: function () {
                var ts = new Date();
                return new Date(ts.getTime() - 900000);
            },
            reload: 60,
        },
        {
            text: '1 ' + I18N.TR('Stunde'),
            name: 'lasthour',
            from: function () {
                var ts = new Date();
                return new Date(ts.getTime() - 3600000);
            },
            reload: 60,
        },
        {
            text: '1 ' + I18N.TR('Tag'),
            name: 'today',
            from: function () {
                var ts = new Date();
                ts.setDate(ts.getDate() - 1);
                return ts;
            },
            reload: 60,
        },
        {
            text: '7 ' + I18N.TR('Tage'),
            name: 'thisweek',
            from: function () {
                var ts = new Date();
                ts.setDate(ts.getDate() - 7);
                return ts;
            },
            reload: 60,
        },
        {
            text: '30 ' + I18N.TR('Tage'),
            name: 'thismonth',
            from: function () {
                var ts = new Date();
                ts.setDate(ts.getDate() - 30);
                return ts;
            },
            reload: 60,
        },
        {
            text: '60 ' + I18N.TR('Tage'),
            name: 'twomonths',
            from: function () {
                var ts = new Date();
                ts.setDate(ts.getDate() - 60);
                return ts;
            },
            reload: 60,
        },
        {
            text: '365 ' + I18N.TR('Tage'),
            name: 'thisyear',
            from: function () {
                var ts = new Date();
                ts.setDate(ts.getDate() - 365);
                return ts;
            },
            reload: 60,
        },
    ];
};

Misc.parseStrIntArray = function (ar) {
    return _.map(ar, function (item) {
        return parseInt(item);
    });
};

Misc.isDeviceValueValid = function (value, series, model) {
    var isValid = true;
    _.each(Consts.DeviceCategory[model.category].invalidDataRules, function (item) {
        if (!isValid || item.value != value) return;
        var seriesParts = series.split('_');
        if (seriesParts.length != 2 || seriesParts[0].toUpperCase() != item.type.toUpperCase()) return;
        var addr = parseInt(seriesParts[1]);
        if (addr < item.from && item.from != -1) return;
        if (addr > item.till && item.till != -1) return;

        if (item.statusMask) {
            var status = model.status || -2;
            switch (status) {
                case -1:
                    status = 0x10000;
                    break;
                case -2:
                    status = 0x20000;
                    break;
            }

            var statusMask = status & item.statusMask;
            if (statusMask != item.statusMask) return;
        }
        isValid = false;
    });
    return isValid;
};

Misc.getAvailableDisplayColumns = function (fields) {
    var data = {};
    Misc.addFieldListData(fields, data);
    return [
        { name: I18N.TR('Geräte Eigenschaften'), items: _.sortBy(data.device, 'name') },
        { name: I18N.TR('Daten'), items: _.sortBy(data.data, 'name') },
        { name: I18N.TR('Verwaltung'), items: _.sortBy(data.meta, 'name') },
    ];
};

Misc.spinnerHTML = function () {
    return '<i class="fa fa-spin fa-spinner"></i>';
};

Misc.warningHTML = function (msg) {
    return '<i class="fa fa-warning" title="' + msg + '"></i>';
};

Misc.getDeviceModelValue = function (model, colKey) {
    if (colKey.startsWith('#_')) {
        colKey = colKey.substr(2, colKey.length);
    }

    if (model.data && model.data[colKey] !== undefined) {
        return { value: model.data[colKey], source: 'data' };
    }

    var result = undefined;
    var colParts = colKey.split('_');

    // is it somewhere in misc
    if (model.info && model.info.misc_data && colParts.length == 2 && colParts[0] == 'misc') {
        var miscValue = model.info.misc_data['' + colParts[1] + ''];
        if (miscValue !== undefined) {
            return { value: Handlebars.escapeExpression(miscValue), source: 'misc' };
        }
    }

    var infoBlocks = {
        ctct: 'contact_person',
        addr: 'address',
    };

    // is it somewhere in info?
    if (colParts.length > 1 && model.info) {
        _.each(infoBlocks, function (infoBlock) {
            infoBlock = model.info[infoBlock];
            if (!infoBlock) return;
            if (infoBlock[colParts[1]] !== undefined) {
                result = infoBlock[colParts[1]];
            }
        });
    }
    if (result) {
        return { value: Handlebars.escapeExpression(result), source: 'info' };
    }

    return { value: Handlebars.escapeExpression(model[colKey]), source: 'model' };
};

Misc.formatDeviceAttr = function (model, attr, availColumns) {
    var valueInfo = Misc.getDeviceModelValue(model, attr);
    switch (valueInfo.source) {
        case 'data':
            var formatInfo = model.formatInfos ? model.formatInfos[attr] : undefined;
            var result = Misc.formatValueUnit(valueInfo.value, attr, availColumns, false, formatInfo);
            return result.value + ' ' + result.unit;
        case 'model':
            if (attr.startsWith('#_')) attr = attr.substr(2, attr.length);

            if (valueInfo.value && Consts.FieldInfo.Date.indexOf(attr) != -1) {
                if (Misc.undefineDate(valueInfo.value) === undefined) {
                    return '--';
                }
                return Misc.formatDate(valueInfo.value);
            }
            break;
    }
    return valueInfo.value || '--';
};

var getTimeString = function (date) {
    return Misc.leadingZero(date.getHours()) + ':' + Misc.leadingZero(date.getMinutes());
};

var getDateString = function (date) {
    return Misc.leadingZero(date.getDate()) + '.' + Misc.leadingZero(date.getMonth() + 1) + '.' + date.getFullYear();
};

Misc.formatDate = function (input) {
    var now_ms = Date.now();
    var now_date = new Date();

    var input_ms = Date.parse(input);
    var input_date = new Date(input_ms);

    var dateString = '';

    if (now_ms - input_ms > 24 * 60 * 60 * 1000 || now_date.getDay() != input_date.getDay()) {
        dateString = getDateString(input_date) + ' ' + getTimeString(input_date);
    } else {
        dateString = getTimeString(input_date);
    }

    return dateString;
};

Misc.isFilterEmpty = function (filter) {
    var j = JSON.stringify(filter);
    return j == '{}';
};

Misc.Waiting = {
    waitingData: {},
    url: '',
    isLoading: false,

    isNoWaiting: function (name) {
        return (
            name == 'devices:status' ||
            name == 'devices:registers' ||
            name == 'device:list:geo' ||
            name == 'device:inconsistent' ||
            name.substring(name.length - 5) === ':scan' ||
            name.substring(0, 7) === 'modbus:' ||
            name == 'device:columns'
        );
    },

    getContainer: function () {
        // is there a visible drop down menu?
        var c = $('.dropdown-menu:visible');
        if (c.length > 0) {
            return c[0];
        }

        c = $('.modal-dialog:visible');
        if (c.length > 0 && c.find('.js-above-spinner').length === 0) {
            return c[0];
        }
    },

    showLoading: function () {
        this.container = this.getContainer();
        if (this.isLoading) {
            var result = Decorator.displayLoading(true, this.container);
            if (!result) {
                setTimeout(function () {
                    Misc.Waiting.showLoading();
                }, 300);
            }
        }
    },

    timers: {
        before: {
            interval: 500,
            active: false,
            onEnd: function () {
                var count = this.getCount();
                if (count > 0 && !this.isLoading) {
                    this.isLoading = true;
                    var ctx = { isLoading: true };
                    this.currentCtx = ctx;
                    Misc.Waiting.showLoading();
                }
            },
        },

        after: {
            interval: 150,
            active: false,
            onEnd: function () {
                var count = this.getCount();
                if (count == 0) {
                    if (this.currentCtx) {
                        this.currentCtx.isLoading = false;
                    }
                    Decorator.displayLoading(false, Misc.Waiting.container);
                    this.isLoading = false;
                }
            },
        },
    },

    isActive: function (tmr) {
        return this.timers[tmr].active;
    },

    wait: function (name, url) {
        // remove URL parameters
        url = url.split('?')[0];
        // url changed? -> drop all waiting requests
        if (this.url != url) {
            this.waitingData = {};
        }
        this.url = url;

        if (this.isNoWaiting(name)) {
            return;
        }

        this.waitingData[name] = (this.waitingData[name] || 0) + 1;

        if (!this.isLoading && !this.isActive('before') && !this.isActive('after')) {
            this.startTimer('before');
        }
    },

    done: function (name) {
        if (this.isNoWaiting(name)) {
            return;
        }

        var count = this.waitingData[name] || 0;
        if (count == 0) {
            console.log('request wait/done mismatch: ' + name + ' @ ' + this.url);
        }

        this.waitingData[name] = count - 1;
        if (this.waitingData[name] <= 0) {
            delete this.waitingData[name];
        }

        var count = this.getCount();
        if (this.isLoading && count == 0 && !this.isActive('after')) {
            this.startTimer('after');
        }
    },

    startTimer: function (type, ctx) {
        var timerInfo = this.timers[type];
        var self = this;
        timerInfo.active = true;
        setTimeout(function () {
            timerInfo.active = false;
            timerInfo.onEnd.apply(self, [ctx]);
        }, timerInfo.interval);
    },

    getCount: function () {
        return _.size(this.waitingData);
    },
};

Misc.deferredFct = function (fct, owner) {
    var defer = $.Deferred();
    setTimeout(function () {
        if (owner) fct.apply(owner, [defer]);
        else fct(defer);
    });
    return defer.promise();
};

Misc.parseAsJSON = function (jsonString) {
    // https://stackoverflow.com/a/20392392
    try {
        var o = JSON.parse(jsonString);
        if (o && typeof o === 'object') {
            // was valid JSON -> return result
            return o;
        }
    } catch (e) {
        // invalid JSON
    }

    return undefined;
};

Misc.cloneAsJSON = function (obj) {
    if (!obj) return undefined;
    return JSON.parse(JSON.stringify(obj));
};

Misc.setVisible = function (selector, visible) {
    var k = $(selector);
    if (visible) k.show();
    else k.hide();
};

Misc.setDisabled = function (selector, isDisabled) {
    var k = $(selector);
    if (isDisabled) {
        k.addClass('disabled');
        k.prop('disabled', true);
    } else {
        k.removeClass('disabled');
        k.prop('disabled', false);
    }
};

Misc.createCache = function (def, options) {
    options = options || {};

    var internalData = {};
    var cacheItemValid = options.cacheItemValidTime || 120000;
    var useLocalStorage = !!options.useLocalStorage;
    var localStorageTime = options.localStorageTime || 600000;
    var contextID = options.context || 'global';

    if (options.deleteLocalStorage) {
        _.each(def, function (value, key) {
            var localKey = 'cache.' + contextID + '.' + key;
            localStorage.removeItem(localKey);
        });
    }

    // returns plain array of required keys
    var getReqList = function (list) {
        var result = [];
        _.each(_.flatten([list]), function (item) {
            if (_.keys(item).length) {
                _.each(item, function (value, k) {
                    if (value) {
                        result.push(k);
                    }
                });
            } else {
                result.push(item);
            }
        });
        return result;
    };

    // sets cache value and saves the data to local storage (when required)
    var setValue = function (key, value, skipLocal) {
        internalData[key] = { value: value, created: new Date() };
        if (skipLocal || !useLocalStorage) return;

        var localKey = 'cache.' + contextID + '.' + key;
        localStorage.setItem(
            localKey,
            JSON.stringify({
                lastUpdate: new Date(),
                value: value,
            })
        );
    };

    // checks if current intern value is still valid
    var isItemValid = function (item) {
        if (!item) return false;

        return new Date().getTime() - item.created.getTime() <= cacheItemValid;
    };

    // returns list of keys that need to be retrieved
    var getMissingKeys = function (keys) {
        var missingFct = function () {
            return Misc.selectWhere(keys, function (k) {
                return !isItemValid(internalData[k]);
            });
        };
        var missing = missingFct();

        // attempt to read the data from local storage
        if (useLocalStorage) {
            _.each(missing, function (key) {
                var localKey = 'cache.' + contextID + '.' + key;
                var localItem = localStorage.getItem(localKey);
                if (localItem) localItem = JSON.parse(localItem);
                if (localItem && new Date().getTime() - new Date(localItem.lastUpdate).getTime() < localStorageTime) {
                    setValue(key, localItem.value, true);
                    // attempt to lazy-update the local storage value
                    var defFct = def[key];
                    if (!defFct) throw 'undefined key: ' + key;

                    setTimeout(function () {
                        defFct(function (value) {
                            setValue(key, value);
                        });
                    });
                }
            });

            missing = missingFct();
        }

        return missing;
    };

    var cache = {
        require: function (reqList, callback) {
            reqList = getReqList(reqList);
            var missingList = getMissingKeys(reqList);
            if (!missingList.length) {
                callback();
                return;
            }

            _.each(missingList, function (key) {
                var defFct = def[key];
                if (!defFct) {
                    throw 'undefined key: ' + key;
                }

                var setter = function (value) {
                    setValue(key, value);
                    var newMissingList = getMissingKeys(reqList);
                    if (!newMissingList.length) {
                        callback();
                    }
                };

                defFct(setter);
            });
        },
    };

    _.each(def, function (value, key) {
        Object.defineProperty(cache, key, {
            get: function () {
                var item = internalData[key];
                if (!isItemValid(item)) {
                    cache.require(key, function () {});
                }
                if (item) return item.value;
            },
        });
    });

    return cache;
};

Misc.sortStrings = function (ar) {
    ar = ar || [];
    ar.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
};

Misc.correctSortCol = function (col) {
    col = col || '';
    if (col.startsWith('misc_')) {
        return col.split('misc_')[1] || '';
    }
    return col;
};

var getPresetData = function (categories, userPermissions, subsetCapabilities) {
    var presetData = {
        none: {},
    };

    function isPresetValid(p) {
        var isValid = true;
        _.each(p, function (ro, perm) {
            isValid = isValid && userPermissions[perm] !== undefined && (ro || !userPermissions[perm]);
        });
        return isValid;
    }

    if (isPresetValid(subsetCapabilities)) {
        presetData.all = Misc.cloneAsJSON(subsetCapabilities);
    }

    _.each(categories, function (category) {
        _.each(Consts.PermissionPresets, function (preset) {
            var values = (Consts.DeviceCategory[category].permissions || {})[preset.name];
            if (!values) {
                return;
            }

            // adapt values to current devices
            var deviceValues = {};
            _.each(values, function (ro, perm) {
                if (subsetCapabilities[perm] !== undefined) {
                    deviceValues[perm] = ro || subsetCapabilities[perm];
                }
            });

            // check if allPermissions contains all of the permissions with at least given read-only right
            if (isPresetValid(deviceValues)) {
                _.each(deviceValues, function (v, k) {
                    presetData[preset.name] = presetData[preset.name] || {};
                    presetData[preset.name][k] =
                        presetData[preset.name][k] === undefined ? v : presetData[preset.name][k] && v;
                });
            }
        });
    });

    return presetData;
};

function matchesPermissionsPreset(presetData, selected, name) {
    var preset = presetData[name] || {};
    if (_.keys(selected).length != _.keys(preset).length) return false;

    var isMatch = true;
    _.each(preset, function (ro, perm) {
        isMatch = isMatch && ro == selected[perm];
    });

    return isMatch;
}

Misc.initPermissionsControl = function (className, isUnion) {
    var data = {};

    function buildPresetData() {
        data.presetData = getPresetData(data.categories, data.allPermissions, data.subsetCapabilities);
    }

    function containsPreset(name) {
        if (!data.presetData) buildPresetData();
        return !!data.presetData[name];
    }

    function matchesPreset(selected, name) {
        return matchesPermissionsPreset(data.presetData, selected, name);
    }

    function createAllPermissions() {
        var base = {};
        _.each(data.subsetCapabilities, function (value, key) {
            if (data.baseSubset[key] !== undefined) base[key] = value || data.baseSubset[key];
        });
        data.allPermissions = base;
    }

    return {
        getSerializedData: function () {
            if (!data.allPermissions) {
                createAllPermissions();
            }

            var presets = Misc.cloneAsJSON(Consts.PermissionPresets);
            _.each(presets, function (item) {
                // can see?
                item.visible = containsPreset(item.name);
                item.selected = matchesPreset(data.selected, item.name);
            });

            return {
                presets: presets,
                permissions: _.map(_.keys(data.allPermissions), function (id) {
                    return {
                        id: id,
                        writeVisible: data.allPermissions[id] === false,
                        isFull: data.selected[id] === false,
                        isReadOnly: data.selected[id] === true,
                        isNone: data.selected[id] === undefined,
                    };
                }),
                className: className,
            };
        },

        getSelected: function () {
            return data.selected;
        },

        getAllPermissions: function () {
            if (!this.allPermissions) createAllPermissions();
            return Misc.cloneAsJSON(data.allPermissions);
        },

        setBasePermissions: function (rightsSubset) {
            data.baseSubset = rightsSubset;
        },

        setCapabilities: function (baseCapabilities, categories) {
            data.subsetCapabilities = Misc.cloneAsJSON(baseCapabilities);
            data.categories = Misc.cloneAsJSON(categories);

            if (!data.categories) {
                data.categories = _.map(_.keys(Consts.CategoryData), function (f) {
                    return Consts.CategoryData[f].category;
                });
            }
        },

        setDevices: function (devices) {
            if (!(devices || []).length) return;

            var subset = Misc.cloneAsJSON(devices[0].get('capabilities'));
            var cats = {};
            _.each(devices, function (d) {
                var cap = d.get('capabilities');
                cats[d.get('category')] = true;

                _.each(subset, function (value, key) {
                    if (cap[key] === undefined) delete subset[key];
                    else subset[key] = value || cap[key];
                });
            });

            data.subsetCapabilities = subset;
            data.categories = _.keys(cats);
        },

        setSelected: function (accessRights) {
            if (!data.allPermissions) createAllPermissions();
            data.selected = {};
            _.each(accessRights, function (ro, perm) {
                if (data.allPermissions[perm] !== undefined) {
                    data.selected[perm] = ro || data.allPermissions[perm];
                }
            });
        },

        initEvents: function (updateFct) {
            $('.' + className + '.js-perm-set').on('click', function (e) {
                var obj = $(e.currentTarget);
                var btnInfo = { id: obj.data('p-id'), value: obj.data('p-value') };
                switch (btnInfo.value) {
                    case 'ro':
                        data.selected[btnInfo.id] = true;
                        break;
                    case 'full':
                        data.selected[btnInfo.id] = false;
                        break;
                    case 'remove':
                        delete data.selected[btnInfo.id];
                        break;
                    default:
                        var presetData = data.presetData[btnInfo.value] || {};
                        data.selected = Misc.cloneAsJSON(presetData);
                }
                updateFct();
            });
        },
    };
};

Misc.getPermissionsRoleName = function (model) {
    var foundPr = undefined;

    var presetData = getPresetData([model.context.category], model.access_rights, model.context.capabilities);
    _.each(Consts.PermissionPresets, function (presetInfo) {
        if (foundPr || !presetData[presetInfo.name]) return;

        if (matchesPermissionsPreset(presetData, model.access_rights, presetInfo.name)) {
            foundPr = presetInfo.roleName || presetInfo.text;
        }
    });

    return foundPr ? foundPr : I18N.TR('Angepasst');
};

Misc.getFieldGroup = function (col) {
    if (col.field_type == Consts.FieldGroup.Device) {
        if (col.id.startsWith('ctct_') || col.id.startsWith('addr_')) return Consts.FieldGroup.Meta;
    }

    return col.field_type;
};

Misc.getFieldName = function (col, categories) {
    // already known? return it
    if (col.dbName) return col.dbName;

    if (col.nameByCategory) {
        var name = _.sortBy(
            _.uniq(
                Misc.selectWhere(
                    _.keys(col.nameByCategory),
                    function (k) {
                        var c = categories || col.relatedCategory;
                        return (
                            col.nameByCategory[k] &&
                            (c === undefined || c == k || (c && !c.substring && c.indexOf(k) >= 0))
                        );
                    },
                    function (k) {
                        // TODO: The following approach for translating each part of a combined
                        //       name works. However, there are some problems if the user changes
                        //       the language settings: because the translated strings are used as
                        //       keys, his/her column definition might get inconsistent and contain
                        //       unavailable columns.
                        return I18N.TR(col.nameByCategory[k]);
                    }
                )
            )
        ).join(' / ');
        return name;
    }

    // attempt to locate in meta info
    var name = undefined;
    _.each(Consts.MetaTableColumns, function (colItem) {
        if (name) return;
        if (col.id == colItem.id || '#_' + col.id == colItem.id) {
            name = colItem.name;
        }
    });
    if (name) {
        return name;
    }

    var nameByCategory = {};
    _.each(Consts.CategoryData, function (catData) {
        var catName = catData.category;
        var name = undefined;
        _.each(catData.columns, function (colItem) {
            if (name) return;
            if (col.id == colItem.id || '#_' + col.id == colItem.id) {
                name = colItem.name;
            }
        });

        nameByCategory[catName] = name;
    });

    var uniqNames = _.uniq(_.compact(_.values(nameByCategory)));
    if (uniqNames.length == 1) {
        col.dbName = uniqNames[0];
        return col.dbName;
    } else {
        col.nameByCategory = nameByCategory;
        if (uniqNames.length) {
            return Misc.getFieldName(col, categories);
        }
    }
    return undefined;
};

Misc.fieldToColumnName = function (fieldName, fieldType) {
    switch (fieldType) {
        case Consts.FieldGroup.Device:
            return '#_' + fieldName;
        case Consts.FieldGroup.Meta:
            return '#_misc_' + fieldName;
    }

    return fieldName;
};

Misc.columnNameToField = function (colName) {
    colName = colName || '';
    if (colName.startsWith('#_misc_')) return colName.substr(7);
    if (colName.startsWith('#_')) return colName.substr(2);
    return colName;
};

Misc.isFilterTypeCombined = function (filterTypes) {
    filterTypes = filterTypes || [];
    var cnt = { true: 0, false: 0 };
    _.each(filterTypes, function (x) {
        cnt[x == Consts.CategoryData.Virtual.type]++;
    });

    return cnt[true] && cnt[false];
};

Misc.isFilterTypeVirtual = function (filterTypes) {
    return (
        Misc.countWhere(filterTypes || [], function (item) {
            return item == Consts.CategoryData.Virtual.category;
        }) > 0
    );
};

Misc.isVirtual = function (id) {
    id = id || '';
    var prefix = id.indexOf('_') > 0 ? id.split('_')[0] : id;
    return Consts.ValueTypesVirtual[prefix];
};

Misc.getValueTypeClass = function (type) {
    return Strings.getValueTypeClass(type);
};

Misc.getValueLikeCoil = function (type) {
    return Misc.getValueTypeClass(type) == 'MBC';
};

Misc.getValueLikeRegister = function (type) {
    return Misc.getValueTypeClass(type) == 'MBR';
};

Misc.getVirtualAggregation = function (id) {
    var nr = parseInt(id.substr(4, id.length));
    return Consts.AggregationIdx[nr % 100];
};

Misc.addFieldListData = function (fields, root, fieldLookup) {
    _.each(
        {
            device: Consts.FieldGroup.Device,
            meta: Consts.FieldGroup.Meta,
            data: Consts.FieldGroup.Data,
        },
        function (fieldGroup, key) {
            root[key] = _.sortBy(
                Misc.selectWhere(
                    fields,
                    function (field) {
                        return field.fieldGroup == fieldGroup;
                    },
                    function (field) {
                        var result = {
                            name: field.name,
                            id: Misc.fieldToColumnName(field.id, field.field_type),
                            sortValue: field.sortValue || field.name,
                        };

                        if (fieldLookup) {
                            fieldLookup[result.id] = result;
                        }
                        return result;
                    }
                ),
                function (item) {
                    return '' + (item.sortValue || '') + item.name;
                }
            );
        }
    );
};

Misc.getErrors = function (errObj) {
    if (!errObj) return {};
    var result = {};
    result.error = errObj.error || errObj;
    result.error = Consts.ErrorMessages[result.error] || result.error;
    return result;
};

Misc.htmlCols = function (items, colCount, divClass) {
    var rowCount = Math.ceil(items.length / colCount);
    var result = [];
    var mainColSize = Math.floor(12 / colCount);
    var restColSize = 12 - (colCount - 1) * mainColSize;
    var template = require('utils/templates/columns');

    // create columns
    for (var i = 0; i < colCount; i++) {
        result[i] = {
            colSize: i < colCount - 1 ? mainColSize : restColSize,
            items: [],
        };
    }

    // create cols with rows
    var col = -1;
    _.each(items, function (item, idx) {
        if (idx % rowCount == 0) col++;
        result[col].items.push(new Handlebars.SafeString(item));
    });

    // create rows with cols
    var rows = [];
    for (var i = 0; i < rowCount; i++)
        for (var j = 0; j < colCount; j++) {
            rows[i] = rows[i] || { items: [] };
            rows[i].items[j] = result[j].items[i];
        }

    return template({
        rows: rows,
        colCount: colCount,
        divClass: divClass,
    });
};

Misc.getCaption = function (section, key, category) {
    var r = Consts.InfoConfig[category] || {};
    r = r[section] || {};
    return r[key] || Consts.InfoConfig.Default[key];
};

Misc.throttle = function (fct, interval, initialWait) {
    var ctx = {
        isRunning: false,
        wantRun: false,
    };

    var run = function () {
        if (ctx.isRunning) {
            ctx.wantRun = true;
            return;
        }

        ctx.isRunning = true;
        setTimeout(function () {
            fct();
            ctx.wantRun = false;
            setTimeout(function () {
                ctx.isRunning = false;
                if (ctx.wantRun) {
                    run();
                }
            }, interval);
        }, initialWait);
    };

    return run;
};

Misc.equalizeHeight = function ($elements) {
    var maxHeight = 0;
    _.each($elements, function (el) {
        maxHeight = Math.max(maxHeight, $(el).height());
    });
    $elements.height(maxHeight);
};

// returns 'in' as JavaScript object (as-is or JSON parsed if required)
Misc.getJSobject = function (input) {
    if (input == null || input == undefined) {
        return undefined;
    }

    // is string? -> parse from JSON
    if (typeof input == 'string') {
        return JSON.parse(input);
    }

    return input;
};

Misc.getStatusValues = function (categories) {
    var result = [];
    if (categories.length > 1) {
        var cd = Consts.CategoryData.Gateway.statusErrors;
        _.each(['DeviceStatusDeactivated', 'DeviceStatusDelayed', 'DeviceStatusOK'], function (k) {
            result.push({ text: cd.messages[k], value: cd.codes[k] });
        });
        return result;
    }

    var d = (Consts.DeviceCategory[categories[0]] || {}).statusErrors || {};
    _.each(_.keys(d.codes), function (k) {
        result.push({ text: d.messages[k], value: d.codes[k] });
    });

    return result;
};

Misc.templateSet = function (template) {
    require('utils/templates');
    var ctx = {};
    var intf = {};
    template({ ctx: ctx });
    _.each(ctx.items, function (fct, value) {
        intf[value] = function (data) {
            return fct(data);
        };
    });
    return intf;
};

Misc.toggleEvent = function (src, event, handler) {
    var myHandler = function (e) {
        if (handler) {
            handler(e);
        }
    };

    var $src = $(src);

    return {
        on: function (runFirst) {
            var eventFct = $src[event];
            eventFct.apply($src, [myHandler]);
            if (runFirst) {
                myHandler();
            }
        },

        off: function () {
            $src.off(event, myHandler);
        },
    };
};

Misc.cleanObject = function (obj) {
    _.each(obj, function (value, key) {
        if (
            typeof key != 'string' ||
            typeof value == 'function' ||
            value === undefined ||
            value === null ||
            value === NaN ||
            value === 0 ||
            '' + value == 'NaN' ||
            (typeof value == 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0)
        ) {
            delete obj[key];
        }
    });
    return obj;
};

Misc.sortTableByEmail = function ($element) {
    // add a data function to the table header cell
    $element.data('tablesaw-sort', function (ascending) {
        return function (a, b) {
            // ignore rows with data-tablesaw-ignorerow
            if (a.ignored || b.ignored) {
                return 0;
            }

            var emailA = $(a.element).find('.email').text();
            var emailB = $(b.element).find('.email').text();

            var result = emailA >= emailB ? 1 : -1;

            return ascending ? result : -result;
        };
    });
};

Misc.getSignedInt = function (x) {
    return x <= 32767 ? x : x - 65536;
};

Misc.getUnsignedInt = function (x) {
    return x >= 0 ? x : x + 65536;
};

// Ensures that no "active" content is written to the CSV file. Adds double quotes.
// See: https://www.contextis.com/en/blog/comma-separated-vulnerabilities
Misc.quoteCSVrecord = function (line) {
    if (line === undefined) {
        return line;
    }

    _.each(line, function (entry, i) {
        // trim whitespaces
        entry = entry.trim();
        // quote unsafe characters
        if (!Misc.isFloat(entry) && !Misc.isFloat(entry.replace(',', '.'))) {
            entry = entry.replace(/^([=+\-@])/, "'$1");
        }
        // wrap in double quotes
        entry = '"' + entry + '"';

        // save updated entry
        line[i] = entry;
    });

    return line;
};

Misc.isFirmwareSufficient = function (firmware, minRequiredFirmware) {
    var firmware = (firmware || '') + '';
    var fieldsRefFW = minRequiredFirmware.split('.');

    for (var i = 0; i < fieldsRefFW.length; i++) {
        var tmpField = parseInt(firmware.split('.')[i]) || 0;
        if (tmpField < parseInt(fieldsRefFW[i])) {
            return false;
        }
        if (tmpField > parseInt(fieldsRefFW[i])) {
            return true;
        }
    }
    return true;
};

Misc.coalesce = function () {
    for (var i = 0; i < arguments.length; i++) {
        var tmp = arguments[i];
        if (tmp !== undefined) return tmp;
    }
};

// returns true, if the given deviceCapabilities allow access to the given route.
Misc.canAccessRoute = function (route, deviceCapabilities) {
    // user+device can access this route?
    var x = deviceCapabilities[Consts.RouteToCapability[route]] !== undefined;
    // these routes can be accessed by everybody and every device
    return x || _.contains(['alarm-list', 'alarm-configuration'], route);
};

Misc.getPickerDefaultColors = function () {
    return defaultColors;
};

Misc.getDeviceCategoryFromURL = function () {
    var categoryURL = '#' + window.location.href.split('#')[1].split('/')[0];
    var category = '';
    _.each(Consts.DeviceCategory, function (device) {
        if (device.url == categoryURL) {
            category = device.category;
        }
    });
    return category;
};

Misc.buildURL = function (base, obj) {
    var parts = Misc.selectWhere(
        _.keys(obj),
        function (k) {
            return obj[k] !== undefined;
        },
        function (k) {
            return '' + k + '=' + encodeURIComponent(obj[k]);
        }
    );

    if (parts.length == 0) return base;

    if (base.includes('?')) base += '&';
    else base += '?';

    return base + parts.join('&');
};

Misc.evaluateToBool = function (lvalue, operator, rvalue) {
    var operators = {
        '&&': function (l, r) {
            return l && r;
        },
        '==': function (l, r) {
            return l == r;
        },
        '===': function (l, r) {
            return l === r;
        },
        '!=': function (l, r) {
            return l != r;
        },
        '!==': function (l, r) {
            return l !== r;
        },
        '<': function (l, r) {
            return l < r;
        },
        '>': function (l, r) {
            return l > r;
        },
        '<=': function (l, r) {
            return l <= r;
        },
        '>=': function (l, r) {
            return l >= r;
        },
        typeof: function (l, r) {
            return typeof l == r;
        },
        rowEnd: function (l, r) {
            return (l + 1) % r == 0;
        },
        odd: function (l, r) {
            return l % 2 == r;
        },
    };

    return operators[operator](lvalue, rvalue);
};

Misc.modelAction = function (e, deviceID, App, AppState, collection) {
    // quicklinks already exist? -> do nothing
    if ($(e.currentTarget).hasClass('initialized')) {
        return;
    }

    var permissions = App.request('permissions:me', deviceID);
    var device = undefined;
    var reqDevice = undefined;

    if (collection) {
        device = collection.get(deviceID);
    } else {
        reqDevice = App.request('device:model', deviceID);
    }

    $.when(permissions, reqDevice).done(function (permissions, deviceReqData) {
        device = device || deviceReqData;
        var links = AppState.getQuickLinks(device, permissions.data.attributes);
        $(e.currentTarget)
            .next('ul')
            .append(QuickNavigation({ id: deviceID, links: links }));
        $(e.currentTarget).addClass('initialized');
    });
};

Misc.reportModeIconByID = function (id) {
    return (
        Misc.selectWhereFirst(Consts.DeviceReportModes, function (m) {
            return m.id == id;
        }) || {}
    ).icon;
};

Misc.le2be = function (x) {
    return Math.floor((x % 0x100) * 0x100 + x / 0x100);
};

Misc.getSelectionIDs = function (selection) {
    return _.map(_.pairs(selection), function (item) {
        return item[1].id;
    });
};

Misc.hasFilterSet = function (filter, ignoreMap) {
    var allowedFields = {
        search_text: true,
        category: true,
        status: true,
        tags: true,
        groups: true,
        device_groups_excluded: true,
        device_groups: true,
        devices: true,
        selection: true,
        selected_devices: true,
        connections: true,
        map_devices: true,
        conditions: true,
    };

    ignoreMap = ignoreMap || {};
    var count = 0;
    _.each(filter, function (value, key) {
        if (!allowedFields[key]) return;
        if (ignoreMap[key] || !value) return;
        if (key == 'conditions' && value.length == 0) return;
        count++;
    });
    return count > 0;
};

Misc.float32ToBytes = function (x, idx) {
    var f = new Float32Array(1);
    f[0] = x / 1000;
    var barr = new Uint16Array(f.buffer);
    return barr[idx];
};

Misc.evalPrefixed = function (script) {
    var prefixes = {
        'FLOATWORD_L#': function (fct) {
            return function (x) {
                return Misc.float32ToBytes(fct(x), 0);
            };
        },
        'FLOATWORD_H#': function (fct) {
            return function (x) {
                return Misc.float32ToBytes(fct(x), 1);
            };
        },
    };

    var resultFct = function (x) {
        return x;
    };
    _.each(prefixes, function (prefixFct, prefixKey) {
        if (script.startsWith(prefixKey)) {
            resultFct = prefixFct(resultFct);
            script = script.replace(prefixKey, '');
        }
    });
    return resultFct(eval(script.replace(/#/g, '')));
};

Misc.getQuickAnalyzePeriod = function (start, end, deltaStart, deltaEnd) {
    if (deltaEnd === undefined) {
        // use start delta
        deltaEnd = deltaStart;
    }

    var from = Date.parse(start) - deltaStart;
    var till = Date.parse(end) + deltaEnd;
    till = till < from ? Date.now() : till;

    return '&chart_period={"from":' + Math.floor(from / 1000) + ',"till":' + Math.ceil(till / 1000) + '}';
};

Misc.requestChannel = function (limit, requestFct) {
    var threadCount = 0;
    var queue = [];

    var execNext = function () {
        if (queue.length == 0) {
            return;
        }

        var item = queue.shift();

        // execute the request
        var promise = requestFct.apply(null, item.args);
        $.when(promise).done(function (resultParams) {
            var responseParams = arguments;
            setTimeout(function () {
                threadCount--;
                execNext();
            });

            item.defer.resolve.apply(null, responseParams);
        });
    };

    return function (requestArgs) {
        var reqArgs = arguments;
        return Misc.deferredFct(function (defer) {
            queue.push({ defer: defer, args: reqArgs });
            threadCount++;
            if (threadCount <= limit) {
                execNext();
            }
        });
    };
};

Misc.getQuickAnalyzeConfig = function (dataList, columnsInfo) {
    // default data point name resolution
    var getNameByDataPoint = function (dataPoint) {
        return 'DEFAULT ' + dataPoint;
    };

    // columns specified? -> initialize name resolution function
    if (columnsInfo !== undefined) {
        getNameByDataPoint = function (dataPoint) {
            // get defined values by register number ..
            var columnEntry = _.where(columnsInfo.columns, { id: dataPoint });
            // .. filter by category
            columnEntry = _.filter(columnEntry, function (e) {
                return _.indexOf(e.categories, columnsInfo.category) != -1;
            });
            // .. extract names
            var names = [];
            _.each(columnEntry, function (e) {
                if (_.indexOf(names, e.name) == -1) {
                    names.push(e.name);
                }
            });

            if (names.length >= 2) {
                Log.warning('ambiguous data point name ' + dataPoint + ' - using ' + names[0]);
            }
            if (names.length >= 1) {
                return names[0];
            }
        };
    }

    var defaultColor = 'rgb(92, 92, 91)';
    var analyzeColor = {
        // AF
        MBR_10: 'rgb(233, 136, 80)',
        MBR_11: 'rgb(233, 136, 80)',

        // VF
        MBR_13: '#C21732', // color value taken from schema
        MBR_14: '#C21732',
        MBR_15: '#C21732',
        MBR_6523: '#C21732',
        MBR_11000: '#C21732',
        MBR_11004: '#C21732',
        MBR_11008: '#C21732',

        // RüF
        MBR_17: '#4062B0', // color value taken from schema
        MBR_18: '#4062B0',
        MBR_19: '#4062B0',
        MBR_6527: '#4062B0',
        MBR_11001: '#4062B0',
        MBR_11005: '#4062B0',
        MBR_11009: '#4062B0',

        // Stellsignale
        MBR_107: 'rgb(92, 92, 92)',
        MBR_109: 'rgb(92, 92, 92)',
        MBR_111: 'rgb(92, 92, 92)',
        MBR_11017: 'rgb(92, 92, 92)',
        MBR_11023: 'rgb(92, 92, 92)',
        MBR_11029: 'rgb(92, 92, 92)',

        // Sollwerte
        MBR_1000: 'rgb(140, 122, 255)',
        MBR_1033: 'rgb(140, 122, 255)',
        MBR_1200: 'rgb(140, 122, 255)',
        MBR_1233: 'rgb(140, 122, 255)',
        MBR_1400: 'rgb(140, 122, 255)',
        MBR_1433: 'rgb(140, 122, 255)',
        MBR_11100: 'rgb(140, 122, 255)',
        MBR_11133: 'rgb(140, 122, 255)',
        MBR_11200: 'rgb(140, 122, 255)',
        MBR_11233: 'rgb(140, 122, 255)',
        MBR_11300: 'rgb(140, 122, 255)',
        MBR_11333: 'rgb(140, 122, 255)',

        // Pumpen (UPx, ZP)
        MBC_57: 'rgb(92, 92, 92)',
        MBC_58: 'rgb(92, 92, 92)',
        MBC_59: 'rgb(92, 92, 92)',
        MBC_61: 'rgb(92, 92, 92)',
        MBC_4100: 'rgb(92, 92, 92)',
        MBC_4108: 'rgb(92, 92, 92)',
        MBC_4116: 'rgb(92, 92, 92)',

        // TW Fühler
        MBR_16: 'rgb(126, 185, 184)',
        MBR_23: 'rgb(126, 185, 184)',
        MBR_24: 'rgb(126, 185, 184)',
    };

    var getSingleAnalyzeConfig = function (dataPoint) {
        var name = getNameByDataPoint(dataPoint);
        if (name === undefined) {
            return '';
        }

        return (
            '{"id":"' +
            dataPoint +
            '","name":"' +
            name +
            '","color":"' +
            (analyzeColor[dataPoint] || defaultColor) +
            '","device":0,"label":"","field2":"","op":"","display":{"aggregation":"MEAN","timewindow":1,"type":0,"difference":0,"valid":true}}'
        );
    };

    return (
        '&chart_content={"advanced_mode":false,"invalid":false,"lines":[' +
        _.filter(
            _.map(dataList, function (e) {
                return getSingleAnalyzeConfig(e);
            }),
            function (e) {
                return e != '';
            }
        ).join(',') +
        ']}'
    );
};

Misc.splitAlarmValueKey = function (key) {
    var parts = (key && key.split('$')) || [];
    if (!parts[0]) {
        return { id: '', name: '', unit: '' };
    }

    var keyInfo = {
        id: parts[0] || '',
        unit: parts[1] || '',
    };

    parts.splice(0, 2);
    keyInfo.name = parts.join('$');

    return keyInfo;
};

Misc.delayedExec = function (timeInterval) {
    var execFct = undefined;
    var addToExec = function (fct) {
        if (execFct === undefined) {
            execFct = fct;
            setTimeout(function () {
                if (execFct) {
                    execFct();
                }
                execFct = undefined;
            }, timeInterval);
        }
    };

    return addToExec;
};

Misc.errorMessageView = function (id, message, title) {
    return messageView(id, 'box-color-error', message, title || I18N.TR('Fehler'));
};

Misc.infoMessageView = function (id, message, title) {
    return messageView(id, '', message, title !== undefined ? title : I18N.TR('Hinweis'));
};

Misc.isWeatherField = function (field) {
    var item = Misc.selectWhereFirst(Consts.WeatherData, function (wdItem) {
        return wdItem.field == field;
    });
    return !!item;
};

module.exports = Misc;
